export default {
    setLoggedIn({commit}, status) {
        commit('setLoggedIn', status);
    },
    setToken({commit}, token) {
        commit('setToken', token);
    }
}
